var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxPinLeftOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24685 13.0148C2.05076 13.2093 2.04942 13.5259 2.24385 13.7219C2.43828 13.918 2.75486 13.9194 2.95095 13.7249L2.5989 13.3699L2.24685 13.0148ZM6.19922 9.80005L5.84717 9.445L2.24685 13.0148L2.5989 13.3699L2.95095 13.7249L6.55127 10.1551L6.19922 9.80005Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 7.2627L10.9707 8.35547C10.7225 8.47965 10.5373 8.70155 10.459 8.96777L9.25781 13.0508L2.94922 6.74219L7.03223 5.54102C7.29845 5.46271 7.52035 5.27745 7.64453 5.0293L8.7373 2.84375L13.1562 7.2627Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxPinLeftOutline);
export default __webpack_public_path__ + "static/media/icon_16px_pin-left_outline.cf41887e347ea9196f9de1d22fdb10d3.svg";
export { ForwardRef as ReactComponent };